import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import {
  DailyReport,
  EmailCandidatesReportsComponent,
} from '../../components/email-candidates-reports/email-candidates-reports.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-new-candidates-report-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './new-candidates-report.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailCandidatesReportsComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class NewCandidatesReportTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<NewCandidatesReportTemplateData>;
}

export type NewCandidatesReportTemplateData = {
  title: string;
  p1: string;
  offers: DailyReport[];
  offer_link_text: string;
  footer_p1: string;
  footer_link: string;
  footer_link_text: string;
};

export const NewCandidatesReportTemplateMocks: NewCandidatesReportTemplateData[] = [
  {
    title: 'Daily report',
    p1: '4 new candidates in ACME since yesterday.',
    offer_link_text: 'Go to job',
    offers: [
      {
        title: 'Product Designer',
        url: 'http://recruitee.com',
        candidates: [
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John Doe The Third Of Great Bumblebees',
            stage: 'Some stage',
          },
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John doe',
            stage: 'Hit the road Jack',
          },
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John doe',
            stage: 'No more no more no more no more.',
          },
        ],
      },
      {
        title: 'Video Creator',
        url: 'http://recruitee.com',
        candidates: [
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John Doe The Third Of Great Bumblebees',
            stage: 'Some stage',
          },
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John doe',
            stage: 'Hit the road Jack',
          },
          {
            avatar_url:
              'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
            url: 'http://google.com',
            name: 'John doe',
            stage: 'No more no more no more no more.',
          },
        ],
      },
    ],
    footer_p1: 'This email was sent by Recruitee.com',
    footer_link: 'http://recruitee.com',
    footer_link_text: 'Change your notification settings',
  },
];
